export default __webpack_public_path__ + "static/media/Portrett-Inam-tekstet-151220.39ffb073.mp4";